import { m } from 'framer-motion';
import React from 'react';
import './homepage.css'
import { Grid, Container, Typography, Button, Box, Stack, } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useResponsive } from '../../hooks/use-responsive';
import { MotionViewport, varFade, } from '../animate';
import Iconify from '../iconify';


const FreeTrial = styled(Button)(({ theme }) => ({
    backgroundColor: "#C7F760",
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    fontSize: "18px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "& .icon-hover": {
        transition: "color 0.3s ease",
    },
    "&:hover": {
        backgroundColor: "#1E53E8",
        color: "#C7F760",
        "& .icon-hover": {
            color: "#FFFFFF", // Change the icon color to white on hover
        },
    },
}));



function TiredOfTheOrdinary() {
    const mdUp = useResponsive('up', 'md');

    const handleFreeTrialClick = () => {
        const selectedPlan = "Free Trial"; // Only store the plan name

        sessionStorage.setItem("selectedPlan", selectedPlan);
        window.location.href = "/paymenthome"; // Redirect to the payment plan page
    };
    //   const handleBuyNow = () => {
    //     window.location.href = "/plans";
    //   };

    return (
        <Container maxWidth={false} sx={{ position: 'relative', mb: 5, border: '5px solid #1E53E8', overflow: 'hidden', borderRadius: 5 }} component={MotionViewport}
            variants={varFade({ distance: 120, durationIn: 0.9 }).inUp}
        >

            <Box sx={{
                pt: { xs: '150px', md: '60px' },
                pb: { xs: '150px', md: '60px' },
                borderRadius: '8px',

            }}>

                <Grid spacing={2} alignItems="center">
                    <m.div variants={varFade({ distance: 120, durationIn: 0.9 }).inUp} >
                        {mdUp && <Typography variant="h3" className="highlighted"
                            paddingBottom='10px' textAlign='center' fontWeight={800} component="div" gutterBottom>
                            HEY! <br /> TIRED OF THE
                            <span style={{ color: '#1E53E8', fontStyle: 'italic', fontWeight: 800 }} > ORDINARY</span> ? <br />
                            EXPERIENCE THE <span style={{ color: '#1E53E8', fontStyle: 'italic', fontWeight: 800 }} > EXTRAORDINARY</span> WITH <span style={{ color: '#1E53E8', fontStyle: 'italic', fontWeight: 800 }} >MEGACONNECT</span>
                        </Typography>}
                        {!mdUp && <Typography variant="h4" className="highlighted"
                            paddingBottom='10px' marginBottom={5} textAlign='center' component="div" gutterBottom>
                            HEY! <br /> TIRED OF THE
                            <span style={{ color: '#1E53E8', fontStyle: 'italic', fontWeight: 800 }} > ORDINARY</span> ? <br />
                            EXPERIENCE THE <span style={{ color: '#1E53E8', fontStyle: 'italic', fontWeight: 800 }} > EXTRAORDINARY</span> WITH <span style={{ color: '#1E53E8', fontStyle: 'italic', fontWeight: 800 }} >MEGACONNECT</span>
                        </Typography>}

                        <Stack direction='column' sx={{ marginTop: '10px', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid container xs={12} sm={8} md={4} justifyContent='center'  >
                                <FreeTrial variant="contained" fullWidth sx={{ color: "#1E53E8", fontWeight: "bold", background: '#C7F760' }} onClick={handleFreeTrialClick}  >
                                    <Iconify icon="gg:microsoft" width="1.6em" height="1.6em" className="icon-hover" />&nbsp;Get Started for Free
                                    </FreeTrial>
                            </Grid>
                        </Stack>

                    </m.div>
                </Grid>
            </Box>

        </Container>
    );
}

export default TiredOfTheOrdinary;
